const isUrl = (url) => {
  // eslint-disable-next-line no-useless-escape
  const regExp = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regExp.test(url);
};
export default isUrl;
